import React from 'react'
import { connect } from 'react-redux'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { injectIntl } from 'react-intl'
import cn from 'classnames'
import { TYPE_INPUT_BOOLEAN } from 'helpers/logbook'
import MasterEventField from './MasterEvent'

function EventList(props) {
  if (!props.isShow) {
    return null
  }

  const {
    activeForm,
    activeLocusGroup,
    activeLocus,
    onEventValueChange,
    onEventClick,
    activeEvent,
    activeAllEvents,
    formEventList,
    updateValuesList,
    showAllSlaveEvents,
  } = props
  const eventListArray = formEventList.toArray()
  const eventListLength = eventListArray.length

  return (
    <List component="div" className="lbf-list" disablePadding>
      {eventListArray.map((eventInfo, index) => {
        const { slaves, type } = eventInfo
        const isEventOpen = activeEvent === eventInfo.id
        const isEventClickEnable = Array.isArray(slaves) && slaves.length
        const onClick = isEventClickEnable
          ? e => onEventClick(e, eventInfo.id)
          : null
        const multipleEvent = eventListLength > 1

        return (
          <ListItem
            key={index}
            className={cn('lbf-list-item lbf-event-item', {
              'lbf-event-boolean': TYPE_INPUT_BOOLEAN === type,
              'lbf-multiple-events': multipleEvent,
              'lbf-master-event': isEventClickEnable,
              active: isEventOpen || activeAllEvents,
            })}
            data-index={index}
            onClick={onClick}>
            <MasterEventField
              index={index}
              isEventOpen={isEventOpen || activeAllEvents}
              eventInfo={{
                ...eventInfo,
                activeForm,
                activeLocusGroup,
                activeLocus,
              }}
              onEventValueChange={onEventValueChange}
              updateValuesList={updateValuesList}
              showAllSlaveEvents={showAllSlaveEvents}
            />
          </ListItem>
        )
      })}
    </List>
  )
}

export default connect(state => ({
  formEventList: state.getIn(['logbookForm', 'formEventList']),
}))(injectIntl(EventList))
